module.exports = __webpack_public_path__ + "assets/img/video-thumb-1.b206ee74.jpg";